export const ARROW_KEY_UP = 38;
export const ARROW_KEY_DOWN = 40;
export const ARROW_KEY_RIGH = 39;
export const ARROW_KEY_LEFT = 37;

export const VNS_ORDER_MANAGEMENT_LOCATION = 'vns_order_mng_location';
export const LOCALSTORAGE_CART_APPLY_COUPON = 'CART_APPLY_COUPON';
export const LOCALSTORAGE_CART_OPEN_COUPON_SELECTOR =
  'CART_OPEN_COUPON_SELECTOR';

export const userSelectedConstants = {
  TERMINAL: 'terminal',
  TERMINAL_ID: 'terminal_id',
  LOCATION: 'LOCATION_CODE',
  TERMINAL_NAME: 'terminal_name',
  /**
   * allow setting a terminal_id from url query param.
   * the new terminal_id will override setting such as that of ecom-284
   * and will be honored even if it's not in the list of configured terminals
   */
  OVERRIDE_TERMINAL_ID: 'override_terminal_id',

  THREE_LEVEL_LOCATION: 'three_level_location',
  USER_LOCATION: 'user_location',
  TERMINALS: 'terminals',
  IS_GET_GEOLOCATION: 'isGetGeoLocation',
};

export const LOCALSTORAGE_SELECTED_PAYMENT_METHOD = 'selected-payment-method';

export const SESSION_STORAGE_LOCATION_MESSAGE = 'location-message';

export const SESSION_STORAGE_LOCATION_HINT_SHOWED =
  'region-picker-suggestion-popover-closed';
